import PaymentsListWrapper from "../components/PaymentsListWrapper/PaymentsListWrapper";

export default function PaymentsPage() {
    return <PaymentsListWrapper />;
}
